<h2 mat-dialog-title class="perse-dialog-title">
  <!-- <mat-icon class="dialog-icon">warning</mat-icon> -->
  Withdraw Consent
</h2>

<mat-dialog-content>
  @if (isSingleMeter) {
    <div class="mb-4">
      <p class="meter-info">
        Meter Number: <strong>{{ meters[0].meterNumber }}</strong>
      </p>
      <p class="meter-info">
        Address: <strong>{{ meters[0].address }}</strong>
      </p>
    </div>
  } @else {
    <div class="mb-4">
      <p class="meter-info">
        You are about to withdraw consent for <strong>{{ meters.length }} meters</strong>
      </p>
    </div>
  }

  @if (!hasShares) {
    <!-- Simple confirmation when no shares exist -->
    <div class="simple-message">
      <p>Are you sure you want to withdraw consent for {{ isSingleMeter ? 'this meter' : 'these meters' }}?</p>
      <p class="warning-note">This action cannot be undone.</p>
    </div>
  } @else {
    <!-- Elaborate warning when platform shares exist -->
    <div class="simple-message">
      <p>{{ isSingleMeter ? 'This meter is' : 'Some of these meters are' }} currently shared with the following platforms:</p>
    </div>

    <div class="shares-list">
      @for (meter of metersWithShares; track meter.meterNumber) {
        <div class="meter-shares-section">
          @if (!isSingleMeter) {
            <h4 class="meter-number-header">{{ meter.meterNumber }}</h4>
          }
          <mat-list class="shares-mat-list">
            @for (share of getPlatformShares(meter); track share.shareId) {
              <mat-list-item>
                <mat-icon matListItemIcon class="share-icon">business</mat-icon>
                <div matListItemTitle class="share-name">{{ share.shareeName }}</div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
    </div>

    <div class="consequence-message">
      <mat-icon class="consequence-icon">block</mat-icon>
      <div class="consequence-text">
        <p><strong>If you proceed with withdrawal:</strong></p>
        <ul>
          <li>All {{ totalSharesCount }} platform share{{ totalSharesCount > 1 ? 's' : '' }} will be revoked</li>
          <li>The platforms listed above will <strong>no longer be able to access</strong> the meter data</li>
          <li>This action <strong>cannot be undone</strong></li>
        </ul>
      </div>
    </div>

    @if (isSingleMeter) {
      <div class="alternative-action">
        <p class="alternative-text">
          <mat-icon class="alternative-icon">lightbulb</mat-icon>
          <span>If you want to revoke access for specific platforms only, use the "Manage Shares" option instead.</span>
        </p>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  
  @if (hasShares && isSingleMeter) {
    <button mat-stroked-button color="primary" (click)="onManageShares()">
      <mat-icon>manage_accounts</mat-icon>
      Manage Shares
    </button>
  }
  
  <button mat-flat-button color="warn" (click)="onConfirm()">
    <mat-icon>key_off</mat-icon>
    Withdraw Consent
  </button>
</mat-dialog-actions>
